// extracted by mini-css-extract-plugin
export default {"failureForm":"PQyiu","emptyField":"dVIFu","formSection":"rnEJm","requiredLabel":"deHIj","formActions":"F_2ia","formBtn":"Uig0V"};